import React, { useState } from "react";
import "./contactpage.css";
import { FaFacebookF, FaWhatsapp } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { IoLocationOutline } from "react-icons/io5";
import { FaPhone } from "react-icons/fa";
import HeaderBanner from "../../Components/HeaderBanner/HeaderBanner";
import InstagramSlider from "../../Components/IGSection/IGSection";
import FadeInWhenVisible from "../../Utilities/FadeInWhenVisible";
import DeliveryMethodSelector from "../../Components/DeliveryMethodSelector/DeliveryMethodSelector";
import { BUSINESS_WHATSAPP_NUMBER, openWhatsAppChat } from "../../Utilities/whatsapp";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    user_name: "",
    user_email: "",
    message: "",
  });
  const [deliveryMethods, setDeliveryMethods] = useState({
    email: true,
    whatsapp: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (deliveryMethods.whatsapp) {
      openWhatsAppChat(
        [
          "New Contact Message",
          `Name: ${formData.user_name}`,
          `Email: ${formData.user_email}`,
          `Message: ${formData.message}`,
        ].join("\n")
      );
    }

    if (!deliveryMethods.email) {
      setFormData({ user_name: "", user_email: "", message: "" });
      setIsSubmitting(false);
      return;
    }

    const payload = {
      _subject: `New Contact Message from ${formData.user_name}`,
      Name: formData.user_name,
      Email: formData.user_email,
      Message: formData.message,
    };

    fetch("https://formsubmit.co/ajax/zakarry540@gmail.com", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        alert("Message sent successfully! We will get back to you soon.");
        setFormData({ user_name: "", user_email: "", message: "" });
      })
      .catch((error) => {
        console.error(error);
        alert("Failed to send message. Please try again.");
      })
      .finally(() => setIsSubmitting(false));
  };

  return (
    <div className="contactpage">
      <HeaderBanner title="Contact Us" currentPath="Contact Us" />
      <FadeInWhenVisible delay={0.2}>
        <div className="contact-form">
          <div className="contact-left">
            <h6 className="small-header">Contact Us</h6>
            <h3>Get in Touch</h3>
            <p>
              We’re excited to hear from you. Whether you’re ready to start your
              fashion journey or have questions about our services, our team is
              here to help. Fill out the form, send us a message, or simply say
              hello—we’ll get back to you within 24 hours. Let’s create
              something timeless, together.
            </p>
            <div className="contact-links">
              <div className="contact-link">
                <h5>MAIN OFFICE</h5>
                <a href="https://maps.app.goo.gl/">
                  <div className="contact-info">
                    <IoLocationOutline />
                    <p>Accra, Ghana</p>
                  </div>
                </a>
              </div>
              <div className="contact-link">
                <h5>PHONE</h5>
                <a href="tel:233203353727">
                  <div className="contact-info">
                    <FaPhone />
                    <p>+233 20 335 3727</p>
                  </div>
                </a>
              </div>
              <div className="contact-link">
                <h5>EMAIL</h5>
                <a href="mailto:zakarry540@gmail.com">
                  <div className="contact-info">
                    <p>zakarry540@gmail.com</p>
                  </div>
                </a>
              </div>
              <div className="contact-link">
                <h5>FOLLOW US</h5>
                <div className="contact-info">
                  <a href="#">
                    <div className="socials">
                      <FaFacebookF />
                    </div>
                  </a>
                  <a href="#">
                    <div className="socials">
                      <FaTiktok />
                    </div>
                  </a>
                  <a href="https://www.instagram.com/zak_arryy/">
                    <div className="socials">
                      <FaInstagram />
                    </div>
                  </a>
                  <a href={`https://wa.me/${BUSINESS_WHATSAPP_NUMBER}`}>
                    <div className="socials">
                      <FaWhatsapp />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-right">
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="user_name"
                value={formData.user_name}
                onChange={handleInputChange}
                placeholder="Enter Your Name"
                required
              />
              <br />
              <input
                type="email"
                name="user_email"
                value={formData.user_email}
                onChange={handleInputChange}
                placeholder="Enter Email Address"
                required
              />
              <br />
              <textarea
                rows={4}
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Message"
                required
              />
              <br />
              <DeliveryMethodSelector
                className="delivery-method-selector--dark"
                methods={deliveryMethods}
                onChange={setDeliveryMethods}
              />
              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? "SENDING..." : "SEND MESSAGE"}
              </button>
            </form>
          </div>
        </div>
        <div className="contact-map">
          {" "}
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3876.093648086063!2d-0.4027836042252098!3d5.525852807817491!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfdfbbdefd0a95bf%3A0x256f2da761aa02d4!2sZakmus%20Central%20Mosque!5e0!3m2!1sen!2sgh!4v1750663470532!5m2!1sen!2sgh"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.4}>
        <InstagramSlider />
      </FadeInWhenVisible>
    </div>
  );
}
